module.exports = __webpack_public_path__ + "static/media/ElephantSpeech.be177021.svg";